define('uikit/behaviors/fixed.popup.behavior',['require','exports','module','underscore','marionette'],function(require, exports, module) {
  var _  = require('underscore');
  var Mn = require('marionette');

  var FixedPopupBehavior = Mn.Behavior.extend({
    defaults: {
        triggerView: null
    },

    onFirstRender: function() {
      var self = this;
      var previousStyleValue;
      var observer = new MutationObserver(function(mutations) {
        var currentStyleValue = self.$el.attr('style');
        if (previousStyleValue !== currentStyleValue) {
          var triggerView = self.getTrigger();
          self.adjustPosition(triggerView);
        }
        previousStyleValue = currentStyleValue;
      });

      //listen to style changes
      observer.observe(this.el, {
        childList : true,
        subtree   : true,
        attributes: true,
        attributeFilter: ['style']
      });
    },

    getTrigger: function() {
      return this.view._popups? this.view._popups[0].trigger: null;
    },

    adjustPosition: function(triggerView) {
      if (this.$el && triggerView.$el) {
        //var thisViewHeight = this.$el.height();
        var triggerViewOffset = triggerView.$el.offset();
        var triggerViewHeight = triggerView.$el.height();
        var windowHeight = $(window).height();
        var windowTopScroll = $(window).scrollTop();
        var windowLeftScroll = $(window).scrollLeft();

        var topOffset = triggerViewOffset.top - windowTopScroll;
        var windowMiddle = windowHeight / 2;

        // if trigger element is located in the bottom half of the window
        if(topOffset > windowMiddle) {
          this.$el.removeClass('bottom');
          this.$el.addClass('top');

          this.$el.css({
            top: 'auto',
            bottom: (windowHeight - topOffset),
            left: (triggerViewOffset.left - windowLeftScroll),
            right: 'auto'
          });
        }
        else {
          this.$el.removeClass('top');
          this.$el.addClass('bottom');

          this.$el.css({
            top: (topOffset + triggerViewHeight),
            bottom: 'auto',
            left: (triggerViewOffset.left - windowLeftScroll),
            right: 'auto'
          });
        }
      }
    },
  })
  module.exports = FixedPopupBehavior;
});

